import React from "react";
import "../App.css";
import Navbar from "../Components/Navbar";
import Footer from "../Components/Footer";

export default function Blog() {
  return (
    <>
      <Navbar />
      <div class="container body-wrapper">
        <h1>Blog</h1>
      </div>
      <Footer />
    </>
  );
}
